import ConditionSimulatorContainer from './ConditionSimulatorContainer'

export default ConditionSimulatorContainer
